import { SectionHeader } from "@/components/common/section-components/SectionHeader";
import { AppRoutes } from "@/constants/routes";
import { useRoles } from "@/hooks/useRoles";
import { Sucursal, getSucursales } from "@/services/accounts.service";
import { zodResolver } from "@hookform/resolvers/zod";
import { Flex } from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ProductionZoneForm } from "../components/ProductionZoneForm";
import { hasEmptyProductionZoneFormValues } from "../utils/production-zone-form";
import { createProductionZoneHandler } from "./schema/handler-functions";
import {
  ProductionZoneCreationForm,
  productionZoneCreationSchema,
} from "./schema/production-zone-creation.schema";

export const ProductionZoneCreationPage = () => {
  const navigate = useNavigate();
  const { fetchPermissions } = useRoles();

  const [isActive, setIsActive] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [sucursales, setSucursales] = useState<Sucursal[]>([]);
  const [loadingSucursales, setLoadingSucursales] = useState(false);

  useEffect(() => {
    setIsActive(true);
  }, []);

  const fetchSucursalesList = async () => {
    setLoadingSucursales(true);
    const response = await getSucursales();
    setSucursales((response ?? []) as Sucursal[]);
    setLoadingSucursales(false);
  };

  useEffect(() => {
    if (isActive) {
      fetchSucursalesList();
    }
  }, [isActive]);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ProductionZoneCreationForm>({
    resolver: zodResolver(productionZoneCreationSchema),
    defaultValues: {
      nombre: "",
      zonaComercial: [],
      activo: undefined,
    },
  });

  const watchedValues = useWatch({ control });

  const hasNoFilledValues = useMemo(() => {
    return hasEmptyProductionZoneFormValues(watchedValues);
  }, [watchedValues]);

  const handleCancel = () => {
    navigate(AppRoutes.PRODUCTION_ZONES);
  };

  const onSubmit = async (values: ProductionZoneCreationForm) => {
    await createProductionZoneHandler({
      values,
      setLoadingCreate,
      navigate,
      fetchPermissions,
    });
  };

  return (
    <Flex
      as="form"
      onSubmit={handleSubmit(onSubmit)}
      flexDir="column"
      paddingTop="20px"
      gap="12px"
    >
      <SectionHeader
        title="Agregar Zona Productiva"
        addButtonLabel="Guardar"
        cancelButtonLabel="Cancelar"
        handleAdd={handleSubmit(onSubmit)}
        handleCancel={handleCancel}
        addButtonType="button"
        disableAdd={hasNoFilledValues || loadingCreate || loadingSucursales}
        loading={loadingCreate}
      />

      <ProductionZoneForm
        control={control}
        errors={errors}
        sucursales={sucursales}
        isActive={isActive}
        loading={loadingCreate}
        loadingSucursales={loadingSucursales}
      />
    </Flex>
  );
};
